export const BUILD_VERSION = '1791492407';
